import {
  ClockIcon,
  EnvelopeIcon,
  LinkIcon,
  RectangleListIcon,
  SettingsIcon,
} from "../../icons";
import { getPageAllowedRoles } from "../../config/roles";

export const settingsLinks = [
  {
    title: "Communication Settings",
    description:
      "Manage communication defaults, validation, and portal communication behaviour.",
    href: "/communication-settings",
    icon: EnvelopeIcon,
    allowedRoles: getPageAllowedRoles("communication-settings"),
  },
  {
    title: "Entity Audits",
    description:
      "Review the changes users have made to records across the portal.",
    href: "/entity-audits",
    icon: ClockIcon,
    allowedRoles: getPageAllowedRoles("entity-audits"),
  },
  {
    title: "Sitemap",
    description:
      "Configure the portal navigation structure and visible sidebar pages.",
    href: "/sitemap",
    icon: RectangleListIcon,
    allowedRoles: getPageAllowedRoles("sitemap"),
  },
  {
    title: "Warehouse Settings",
    description:
      "Manage Warehouse API configuration, match keys, and queue settings.",
    href: "/warehouse-settings",
    icon: SettingsIcon,
    allowedRoles: getPageAllowedRoles("warehouse-settings"),
  },
  {
    title: "Warehouse Applications",
    description:
      "Create, update, and remove Warehouse applications used by connected systems.",
    href: "/warehouse-applications",
    icon: LinkIcon,
    allowedRoles: getPageAllowedRoles("warehouse-applications"),
  },
];

/** The settings pages the user's roles open. */
export function getVisibleSettingsLinks(
  hasAnyRole: (roles: string[]) => boolean
) {
  return settingsLinks.filter((link) => hasAnyRole(link.allowedRoles));
}
